import React, { useState } from "react";
import {
  Row,
  Label,
  Input,
  Form,
  FormGroup,
  FormFeedback,
  Col,
  Button,
} from "reactstrap";
import { useFormik } from "formik";
import * as yup from "yup";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";

interface BasicInformationProps {
  onSubmit: (values: any) => void;
  onBack: () => void;
  data?: any;
}

const PasswordInformation = ({
  onSubmit,
  onBack,
  data,
}: BasicInformationProps) => {
  //meta title
  document.title = "Ditobanx";
  const [show, setShow] = useState<boolean>(false);
  // const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showVerification, setShowVerification] = useState<boolean>(false);

  const formik: any = useFormik({
    initialValues: {
      password: (data.passwordInfo && data.passwordInfo.password) || "",
      password_verification:
        (data.passwordInfo && data.passwordInfo.password_verification) || "",
    },
    validationSchema: yup.object().shape({
      password: yup
        .string()
        .required("Por favor ingresa tu contraseña")
        .matches(/[A-Z]/, "Debe contener al menos una letra mayúscula")
        .matches(/[a-z]/, "Debe contener al menos una letra minúscula")
        .matches(/\d/, "Debe contener al menos un número")
        .matches(
          /[@$!%*?&#^()_+\-=[\]{};':"\\|,.<>/?]/,
          "Debe contener al menos un carácter especial"
        )
        .min(8, "La contraseña debe tener al menos 8 caracteres"), // opcionalmente mínimo 8 caracteres,
      password_verification: yup
        .string()
        .required("Por favor confirma tu contraseña")
        .oneOf([yup.ref("password")], "Las contraseñas no coinciden"),
    }),
    onSubmit: (values: any) => {
      // console.log("values", values);
      onSubmit(values);
    },
  });

  return (
    <React.Fragment>
      <Form onSubmit={formik.handleSubmit} autoComplete="off">
        <Row>
          {/* Password */}
          <div style={{ padding: "0px 20px" }}>
            <p>Recuerda que la contraseña debe contener:</p>
            <ul style={{ marginLeft: "20px" }}>
              <li>Caracteres especiales [@ _ - . $ # %]</li>
              <li>Numeros [0-9]</li>
              <li>Letras Mayusculas y minusculas [A-Z, a-z]</li>
            </ul>
          </div>
          <Col lg={6}>
            <FormGroup className="mb-3">
              <Label htmlFor="password"> Contraseña </Label>
              <div className="input-group auth-pass-inputgroup">
                <Input
                  id="password"
                  name="password"
                  value={formik.values.password}
                  type={show ? "text" : "password"}
                  placeholder="Enter Password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.password && !!formik.errors.password} // <- más limpio
                />
                <button
                  onClick={(e) => {
                    e.preventDefault(); // <- evita recargar el formulario
                    setShow(!show);
                  }}
                  className="btn btn-light"
                  type="button"
                  id="password-addon"
                >
                  <i className="mdi mdi-eye-outline"></i>
                </button>
                {formik.touched.password && formik.errors.password && (
                  <FormFeedback>{formik.errors.password}</FormFeedback>
                )}
              </div>
            </FormGroup>
          </Col>
          {/* Password Verfication */}
          <Col lg={6}>
            <FormGroup className="mb-3">
              <Label htmlFor="password_verification">
                {" "}
                Confirmar Contraseña{" "}
              </Label>
              <div className="input-group auth-pass-inputgroup">
                <Input
                  name="password_verification"
                  value={formik.values.password_verification}
                  type={showVerification ? "text" : "password"}
                  placeholder="Confirm Password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.password_verification &&
                    !!formik.errors.password_verification
                  }
                />
                <button
                  onClick={() => setShowVerification(!showVerification)}
                  className="btn btn-light"
                  type="button"
                  id="password-addon"
                >
                  <i className="mdi mdi-eye-outline"></i>
                </button>
                {formik.touched.password_verification &&
                  formik.errors.password_verification && (
                    <FormFeedback>
                      {formik.errors.password_verification}
                    </FormFeedback>
                  )}
              </div>
            </FormGroup>
          </Col>
        </Row>
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <button
            type="button"
            className="btn btn-secondary me-2"
            onClick={onBack}
          >
            Regresar
          </button>
          <Button type="submit" className="btn btn-primary">
            Siguiente
          </Button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default PasswordInformation;
